import { css, StyleSheet } from 'aphrodite/no-important';
import * as React from 'react';
import { VrLineHeight } from '../../../theming/verticalRhythm/verticalRhythm';
import { MEDIA_BREAKPOINTS } from '../../../mediaQueries.const';
import {
  MenuLinkDataProps,
  MenuLinkThemeProps,
} from '../../components/navigation/header/primaryHeader/menu/links/MenuLink';
import { useTheme } from '../../../theming/useTheme';
import { generateLinkStyleFromTheme, TextLinkComponent } from '../../partials/link/TextLink';
import {
  MenuSubLink,
  MenuSubLinkDataProps,
} from '../../components/navigation/header/primaryHeader/menu/links/MenuSubLink';
import { ChevronIcon, Directions } from '../../components/navigation/header/ChevronIcon';

/* eslint-disable react/no-unknown-property */

const componentConfigThemeKey = 'menuLink';

const getAmpSideBarLinkStyle = (vrLineHeight: VrLineHeight) => StyleSheet.create({
  wrapper: {
    [MEDIA_BREAKPOINTS.MEDIUM]: {
      margin: `${vrLineHeight[MEDIA_BREAKPOINTS.MEDIUM]}px`,
    },
    [MEDIA_BREAKPOINTS.SMALL]: {
      margin: `${vrLineHeight[MEDIA_BREAKPOINTS.SMALL]}px`,
    },
  },
  title: {
    backgroundColor: 'inherit',
    border: 'inherit',
    paddingRight: 0,
    ':focus': {
      outline: 'none',
    },
  },
  titleAndChevronIconWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
});

const createAmpSideBarSubLink = (link:MenuSubLinkDataProps, index: number) => {
  const { href, text } = link;
  return <MenuSubLink text={text} href={href} key={index} />;
};

export const AMPSideBarLinkComponent:React.FunctionComponent<MenuLinkDataProps & MenuLinkThemeProps> = props => {
  const { href, text, idleColor, vrLineHeight, childrenLinks } = props;
  const style = getAmpSideBarLinkStyle(vrLineHeight);
  const linkStyle = generateLinkStyleFromTheme({ idleColor });

  return (
    <section className={css(style.wrapper)}>
      <h4 className={css(style.title)}>
        <div className={css(style.titleAndChevronIconWrapper)}>
          <TextLinkComponent href={href} linkStyle={linkStyle}>{text}</TextLinkComponent>
          {childrenLinks.length > 0 ? <ChevronIcon direction={Directions.DOWN} color={idleColor} /> : null}
        </div>
      </h4>
      <ul>
        {childrenLinks.map(createAmpSideBarSubLink)}
      </ul>
    </section>
  );
};

const mapThemeProps = (theme: MenuLinkThemeProps) => {
  return {
    vrLineHeight: theme.vrLineHeight,
    idleColor: theme.idleColor,
    activeStateColor: theme.activeStateColor,
  };
};

export const AMPSideBarLink = (props: MenuLinkDataProps) => {
  const themeContext = useTheme(componentConfigThemeKey, mapThemeProps);
  return <AMPSideBarLinkComponent {...themeContext} {...props} />;
};
